import { GetSessionVarsRoute, UpdateSessionVarsRoute } from 'api/session';
import ApiRoute from 'utils/apiRoute';

export const getSessionVarsRoute: GetSessionVarsRoute = new ApiRoute('/session', 'GET');
export const updateSessionVarsRoute: UpdateSessionVarsRoute = new ApiRoute('/session', 'PUT');
